<template>
    <!-- <div class="relative flex-1 flex items-center overflow-hidden max-h-[200px]">
        <div class="absolute z-[1] top-0 left-0 w-full h-full flex justify-center items-center">
            <BaseImg
                :src="article?.image"
                class="w-full flex justify-center items-center"
                loading="w-full min-h-[200px]"
                img-class="max-h-[200px] max-h-inherit h-full object-contain object-center"
            />
        </div>
        <BaseImg
            :src="article?.image"
            class="flex-1 blur-sm h-full opacity-95"
            loading="w-full min-h-[200px]"
            img-class="h-full w-full object-contain object-center"
        />
    </div> -->
    <div class="relative flex-1 flex items-center overflow-hidden blured-max-h">
        <BaseImg
            :src="src"
            class="absolute top-0 left-0 w-full h-full flex justify-center items-center bluring-img opacity-95"
            loading="w-full blured-min-h"
            img-class="blured-max-h w-full h-full object-contain object-center"
        />
        <div class="flex justify-center items-center w-full h-full">
            <BaseImg
                :src="src"
                class="w-full justify-center h-full z-[1] blured-max-h"
                loading="w-full blured-min-h"
                objectFit="contain"
                img-class="!h-auto object-center"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'v-blured-img',
    props: {
        src: {
            type: String,
            default: undefined
        },
        maxHeight: {
            type: String,
            default: '200px'
        },
        minHeight: {
            type: String,
            default: '200px'
        },
        bluring: {
            type: String,
            default: '9px'
        },
    },
}
</script>

<style lang="scss">

.blured-max-h {
    max-height: v-bind(maxHeight);
}
.blured-min-h {
    min-height: v-bind(minHeight);
}
.bluring-img {
    filter: blur(v-bind(bluring));
}

</style>